import { createContext } from "react";

export const RegistrationSectionContext = createContext([]);